export const VER_VERSION = 12;
export const VER_RELEASE = '2'; // (TEST)'; // (ONTWIKKEL)'; // (TEST)';
export const VER_BUILD   = '25.04.14';

export const APP_ID = 12;

export const DASHBOARD_OPENSTAANDE_NOTITIES              = 0;
export const DASHBOARD_ONVOLTOOIDE_TAKENLIJST            = 1;
export const DASHBOARD_SCHERMBOODSCHAP                   = 2;
export const DASHBOARD_OPENSTAANDE_VERKOOPFAKTUREN       = 3;
export const DASHBOARD_OPENSTAANDE_INKOOPFAKTUREN        = 4;
export const DASHBOARD_PERIODE_OMZET                     = 5;
export const DASHBOARD_ONVOLTOOIDE_TAKEN                 = 6;
export const DASHBOARD_VANDAAG                           = 7;
export const DASHBOARD_OFFERTES_ACTUEEL_STATUS           = 8;
export const DASHBOARD_MACHINES_ACTUEEL                  = 9;
export const DASHBOARD_ONVOLTOOIDE_ACTIES_SOORT          = 10;
export const DASHBOARD_ONVOLTOOIDE_ACTIES_MEDEWERKER     = 11;
export const DASHBOARD_MAAND_OMZET                       = 12;
export const DASHBOARD_VERKOOPKANSEN_ACTUEEL             = 13;
export const DASHBOARD_OPENSTAANDE_MAILS                 = 14;
export const DASHBOARD_ORDERBEVESTIGINGEN_ACTUEEL        = 15;
export const DASHBOARD_REPARATIES_ACTUEEL                = 16;
export const DASHBOARD_REPARATIES_ACTUEEL_MONTEUR        = 17;
export const DASHBOARD_OFFERTES_ACTUEEL_MEDEWERKER       = 18;
export const DASHBOARD_ASSEMBLAGES_ACTUEEL               = 19;
export const DASHBOARD_OPENSTAANDE_NOTITIES_STATUS       = 20;
export const DASHBOARD_VERKOOPKANSEN_ACTUEEL_STATUS      = 21;
export const DASHBOARD_VERZENDBONNEN_ACTUEEL             = 22;
export const DASHBOARD_OPENSTAANDE_NOTITIES_MEDEWERKER   = 23;
export const DASHBOARD_OPENSTAANDE_KLANTBESTELLINGEN     = 24;

export const DASHBOARD_BEDRIJFSGROEP_START               = 101;
export const DASHBOARD_BEDRIJFSGROEP_END                 = 199;

export const DASHBOARD_DAG_EXTERNE_ACTIES                = 0;
export const DASHBOARD_DAG_INTERNE_ACTIES                = 1;
export const DASHBOARD_DAG_RELATIES                      = 2;
export const DASHBOARD_DAG_NOTITIES                      = 3;
export const DASHBOARD_DAG_TAKEN                         = 4;
export const DASHBOARD_DAG_EMAILS                        = 5;
export const DASHBOARD_DAG_MACHINES                      = 6;
export const DASHBOARD_DAG_NIEUWE_REPARATIEBONNEN        = 7;
export const DASHBOARD_DAG_VERKOOPFAKTUREN               = 8;
export const DASHBOARD_DAG_VERKOOPCREDITNOTAS            = 9;
export const DASHBOARD_DAG_VERZENDBONNEN                 = 10;
export const DASHBOARD_DAG_ORDERBEVESTIGINGEN            = 11;
export const DASHBOARD_DAG_OFFERTES                      = 12;
export const DASHBOARD_DAG_VERKOOPKANSEN                 = 13;
export const DASHBOARD_DAG_INKOOPFAKTUREN                = 14;
export const DASHBOARD_DAG_INKOOPCREDITNOTAS             = 15;
export const DASHBOARD_DAG_BESTELBONNEN                  = 16;
export const DASHBOARD_DAG_VERKOOPBETALINGEN             = 17;
export const DASHBOARD_DAG_INKOOPBETALINGEN              = 18;
export const DASHBOARD_DAG_HERINNERINGEN                 = 19;
export const DASHBOARD_DAG_KLANTBESTELLINGEN             = 20;
export const DASHBOARD_DAG_UIT_TE_VOEREN_REPARATIEBONNEN = 21;

export const NOTITIE_GLYPH_PHONE                         = 0;
export const NOTITIE_GLYPH_MAIL_BACK                     = 1;
export const NOTITIE_GLYPH_VEHICLE_CAR_SIDE              = 2;
export const NOTITIE_GLYPH_VEHICLE_VAN_SMALL             = 3;
export const NOTITIE_GLYPH_DELIVERY                      = 4;
export const NOTITIE_GLYPH_CONTACT_GROUP                 = 5;
export const NOTITIE_GLYPH_QUOTE    	                 = 6;
export const NOTITIE_GLYPH_MONEY_COINS                   = 7;
export const NOTITIE_GLYPH_SUPPORT                       = 8;
export const NOTITIE_GLYPH_EXPORT_SPREADSHEET            = 9;
export const NOTITIE_GLYPH_BUG                           = 10;
export const NOTITIE_GLYPH_FORUM                         = 11;
export const NOTITIE_GLYPH_PHONE_2                       = 12;
export const NOTITIE_GLYPH_PRINTER                       = 13;
export const NOTITIE_GLYPH_SETTINGS_OPTIONS              = 14;
export const NOTITIE_GLYPH_CALENDAR                      = 15;
export const NOTITIE_GLYPH_TABLE_DATABASE                = 16;
export const NOTITIE_GLYPH_ERROR_BUTTON                  = 17;
export const NOTITIE_GLYPH_COMPUTER_GEAR                 = 18;
export const NOTITIE_GLYPH_MICROPHONE                    = 19;
export const NOTITIE_GLYPH_INTERNET                      = 20;
export const NOTITIE_GLYPH_ARCHIVE_BUSINESS              = 21;
export const NOTITIE_GLYPH_APPLICATION_GEAR 	         = 22;
export const NOTITIE_GLYPH_GEARS_GEAR                    = 23;
export const NOTITIE_GLYPH_SOFTWARE_BOX                  = 24;
export const NOTITIE_GLYPH_CONTACT_CARD                  = 25;
export const NOTITIE_GLYPH_PHONE_1                       = 26;
export const NOTITIE_GLYPH_REPORT                        = 27;
export const NOTITIE_GLYPH_STORAGE_SHELVES               = 28;

export const WOS_GEEN                        = 0;
export const WOS_WORDT_AANGEMAAKT            = 1;
export const WOS_KAN_WORDEN_BEWERKT          = 2;
export const WOS_WORDT_BEWERKT               = 3;
export const WOS_BESCHIKBAAR_VOOR_VERWERKING = 4;
export const WOS_VERWERKT                    = 5;

export const WRI_GEEN                        = 0;
export const WRI_WORDT_AANGEMAAKT            = 1;
export const WRI_PRIJSOPGAVE                 = 2;
export const WRI_BESCHIKBAAR_VOOR_UITVOERING = 3;
export const WRI_WORDT_UITGEVOERD            = 4;
export const WRI_IS_UITGEVOERD               = 5;
export const WRI_BESCHIKBAAR_VOOR_VERWERKING = 6;
export const WRI_IS_VERWERKT                 = 7;
export const WRI_GEREED                      = 8;
export const WRI_AFGEHANDELD                 = 9;

export const P_DEBNOTE = 87;
